import ReactEcharts from "echarts-for-react"

function HKVEchart(props) {
  const { chartDidMount, height, options = {}, width, spec } = props

  return (
    <ReactEcharts
      option={options}
      onChartReady={(instance) => {
        if (chartDidMount) {
          instance.key = spec
          chartDidMount(instance)
        }
      }}
      opts={{ renderer: "canvas" }}
      style={{
        width: width ? width : "100%",
        height: height ? height : "100%"
      }}
      autoResize
    />
  )
}

export default HKVEchart